import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import RCAComplianceCorporate from "./RCAComplianceCorporate";
import RCAComplianceByMill from "./RCAComplianceByMill";
import RCAActionPlansPerMill from "./RCAActionPlansPerMill";
import RCAMethodologyByMill from "./RCAMethodologyByMill";

const RCACompliance = () => {
    const mainClasses = useRCAMainStyles();

    return (
        <>
            <div className={mainClasses.contentWrapper}>
                <RCAComplianceCorporate />
            </div>
            <div className={mainClasses.contentWrapper}>
                <RCAComplianceByMill />
            </div>
            <div className={mainClasses.tablesWrapper}>
                <RCAActionPlansPerMill />
                <RCAMethodologyByMill />
            </div>
        </>
    );
};

export default RCACompliance;
